export default function Form({ children, title }) {
    return (
        <div className="Form">
            <h3 className="FormTitle">{title}</h3>
            <div className="FormContent">
                {children}
            </div>
        </div>
    )
}